import HttpClient from '@/common/boot/HttpClient';


const listarConclusoes = ({ commit }) => {
  commit('LOADING', true)

  HttpClient.get('gestao-producao/conclusoes').then(response => {
    commit('INSERE_CONCLUSOES', response.data.data)
    return response.data
  })
  .finally(()=> {
    commit('LOADING', false)
  })
}

export {
  listarConclusoes
}